import { FC, useState } from 'react'
import { YhBox } from '@/components/YhBox'
import { Button, Tabs, Upload } from 'antd'
import { RouterParamType } from '@/model/navModel'
import { useRepairTemplateDetailsModel } from './repairTemplateDetailsModels'
import { ItemTableBox } from './itemTableBox'
import { MaterialTableBox } from './materialTableBox'
import { YhAuth } from '@/components/auth/YhAuth'
import { ResourceAuthEnum } from '@/types/VrmResoureAuthEnum'
import { importPropsConfig } from '@/utils/importFile'
import useGlobalModel from '@/model/globalModel'
import { globalPrompt } from '@/components/message'


export const TabsBox: FC<RouterParamType> = (detailsInfo, IFormRef) => {
    const { shopAndOrg: { shopId }, setLoadingInfo } = useGlobalModel()
    const [tabActives, setTabActives] = useState<string>('itemList');
    const {
        detailAddForm, detailEditForm, detailLookForm, detialDownloadTpl, transformsToPoItemDetailList, transformsToPoMaterialDetailList
    } = useRepairTemplateDetailsModel();
    const typeForm = {
        add: detailAddForm,
        edit: detailEditForm,
        look: detailLookForm
    }
    const importCallback = async (list: any) => {
        setLoadingInfo({ loadingVisible: false })
        if (!list) return;
        //项目导入
        let newItemsList: any = []
        let itemMessage: any = []
        list.repairItemsExcelVoList.map((item: any) => {
            if (item.success) {
                newItemsList.push(item)
            } else {
                itemMessage.push(item.msg)
            }
        })
        itemMessage.length !== 0 && globalPrompt('message', { text: `${itemMessage.join(',')}`, type: 'warning' })
        transformsToPoItemDetailList(detailsInfo?.mode, newItemsList)
        //商品导入
        let newMaterialsList: any = []
        let materialMessage: any = []
        list.repairMaterialsExcelVoList.map((item: any) => {
            if (item.success) {
                newMaterialsList.push(item)
            } else {
                materialMessage.push(item.msg)
            }
        })
        materialMessage.length !== 0 && globalPrompt('message', { text: `${materialMessage.join(',')}`, type: 'warning' })
        transformsToPoMaterialDetailList(detailsInfo?.mode, newMaterialsList)
        setLoadingInfo({ loadingVisible: false, txt: "" });
    }
    return (
        <YhBox style={{ padding: '0 10px', position: 'relative', height: 'calc(100vh - 740px)', minHeight: '800px', overflowY: "auto" }} >
            <Tabs defaultActiveKey={"itemList"} onChange={(e) => { setTabActives(e) }}>
                <Tabs.TabPane tab="维修项目" key="itemList">
                    <ItemTableBox {...detailsInfo} />
                </Tabs.TabPane>
                <Tabs.TabPane tab="维修用料" key="materialList">
                    <MaterialTableBox {...detailsInfo} />
                </Tabs.TabPane>
            </Tabs>
            <div style={{ height: '50px', display: 'flex', alignItems: 'center', justifyContent: 'end', position: 'absolute', right: '20px', top: '0' }}>
                <YhAuth resCode={ResourceAuthEnum.VRM2_DATA_REPAIRTEMPLATE_DE_DETIALIMPORT}>
                    <Upload showUploadList={false} className="mr-10 ml-10" {...importPropsConfig(`/zzw-vrm/repairTemplate/import`, importCallback, () => setLoadingInfo({ loadingVisible: true, txt: "快速导入中" }))}>
                        <Button
                            disabled={(typeForm[detailsInfo?.mode].serviceTypeCode && typeForm[detailsInfo?.mode].brandCode && typeForm[detailsInfo?.mode].vehicleTypeCode) ? false : true}
                            className="mr-5"
                            type="primary"
                            shape="round">导入</Button>
                    </Upload>
                </YhAuth>
                <YhAuth resCode={ResourceAuthEnum.VRM2_DATA_REPAIRTEMPLATE_DE_DETIALEXPORT}>
                    <Button
                        className="mr-5"
                        type="primary"
                        shape="round"
                        onClick={detialDownloadTpl}
                    >下载模板</Button>
                </YhAuth>
            </div>
        </YhBox >
    )
}
